<template>
    <div v-on:blur="closeModal()" class="offcanvas offcanvas-end" id="card-detail-view-canvas" tabindex="-1" role="dialog" aria-labelledby="card-detail-view-canvas-label" aria-hidden="true" v-if="card">
        <div class="offcanvas-header" v-if="card">
            <div class="w-100">
                <h3 class="text-center text-dark">
                    {{ card.name }}

                    <i class="fa-solid fa-check-circle text-success" v-if="card.hasOwnProperty('is_in_set_collection') && card.is_in_set_collection"></i>
                    <i class="fa-solid fa-times-circle text-danger" v-else></i>

                    <span v-if="card.amount > 1" class="ml-2 badge rounded-pill bg-info" v-text="card.amount"></span>
                    <a href="javascript:" v-on:click="closeModal()"><i class="fa-solid fa-times float-end" style="font-size: 1.5em;"></i></a>
                </h3>
            </div>
        </div>

        <div class="offcanvas-body" v-if="card">
            <a :href="getCardImageUrl(card)" data-lightbox="card-single-view">
                <img v-on:click="console.log(card)" :src="getCardImageUrl(card)" class="card-image mb-3" alt="card image"/>
            </a>

            <div v-if="card.set" style="height: 5em;">
                <a :href="'/gallery/'+card.set.id" class="float-end">
                    <img class=" set-logo mb-3" :src="card.set.images.logo" alt=""/>
                </a>
                <strong>{{ $t('cardInfo.set') }}: </strong> {{ card.set.name }} <img v-if="card.set.id !== 'base1'" class="set-icon" :src="card.set.images.symbol"/><br/>
                <strong>{{ $t('cardInfo.series') }}: </strong>{{ card.set.series }}
            </div>

            <span v-if="card.artist">
                <strong>{{ $t('cardInfo.artist') }}:</strong> {{ card.artist }}<br/>
            </span>

            <span v-if="card.rarity">
                <strong>{{ $t('cardInfo.rarity') }}:</strong> {{ card.rarity }}<br/>
            </span>

            <span v-if="card.types">
                <strong>{{ $t('cardInfo.type') }}: </strong> <img v-for="type in card.types" :src="'/assets/dipocaco/type-icons/'+type+'.png'" alt=""><br/>
            </span>

            <div class="row p-0" v-if="(card.weaknesses && card.weaknesses.length) || (card.resistances && card.resistances.length)">
                <span v-if="card.weaknesses && card.weaknesses.length" class="col-6 p-0">
                    <strong>{{ $t('cardInfo.weakness') }}:</strong>
                    <span v-for="weakness in card.weaknesses">
                        <img loading="lazy" :src="'/assets/dipocaco/type-icons/'+weakness.type+'.png'" alt=""> {{ weakness.value }}
                    </span>
                    <br/>
                </span>

                <span v-if="card.resistances && card.resistances.length" class="col-6 p-0">
                    <strong>{{ $t('cardInfo.resistance') }}:</strong>
                    <span v-for="resistance in card.resistances">
                        <img :src="'/assets/dipocaco/type-icons/'+resistance.type+'.png'" alt=""> {{ resistance.value }}
                    </span>
                    <br/>
                </span>
            </div>

            <span class="mt-2">
                <strong>{{ $t('cardInfo.id') }}:</strong>
                <span class="ms-1" v-on:click="copyCardID(card.id)">{{ card.id }}</span>
                <br/>
            </span>

            <div v-if="card.userCollectionCardId && card.collectionOwnerId === $store.state.user.user_id" class="mt-2">
                <a href="javascript:" class="btn btn-danger w-100" v-on:click="removeCardFromCollection(card.userCollectionCardId)">
                    {{ $t('cardInfo.removeFromCollection') }}
                </a>
            </div>

            <div v-if="card.userCollectionCardId && card.collectionOwnerId === $store.state.user.user_id" class="mt-2">
                <a href="javascript:" class="btn btn-danger w-100" v-on:click="removeAllFromCardFromCollection(card.userCollectionCardId)">
                    {{ $t('cardInfo.removeAllFromCollection') }}
                </a>
            </div>

            <div v-if="card.userCollectionCardId && card.collectionIsCustom && card.collectionOwnerId === $store.state.user.user_id" class="mt-2">
                <a href="javascript:" class="btn btn-success w-100" v-on:click="setAsCollectionCover(card)">
                    {{ $t('cardInfo.setCollectionCover') }}
                </a>
            </div>

            <template v-if="card?.collectionOwnerId !== $store.state.user.user_id">
                <div v-if="$store.state.user.wishlist.map(c => c.id).includes(card.id)" class="mt-2">
                    <a href="javascript:" class="btn btn-danger w-100" v-on:click="$store.commit('toggleWishlist', card.id)">
                        {{ $t('cardInfo.removeWishlist') }} <i class="fa-solid fa-heart-broken"></i>
                    </a>
                </div>

                <div v-else class="mt-2">
                    <a href="javascript:" class="btn btn-success w-100" v-on:click="$store.commit('toggleWishlist', card.id)">
                        {{ $t('cardInfo.addWishlist') }} <i class="fa-solid fa-heart"></i>
                    </a>
                </div>
            </template>

            <div v-if="!gallery" class="mt-2">
                <a href="javascript:" class="btn btn-danger w-100 mb-2" v-on:click="$store.commit('sellCard', {card: card})">
                    {{ $t('cardInfo.sell') }} {{ getPrice(card) }} <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon">
                </a>

                <a v-if="card.amount > 1" href="javascript:" class="btn btn-danger w-100 mb-2" v-on:click="$store.commit('sellAllOfOneCard', {card: card})">
                    {{ $t('cardInfo.sellX', {amount: card.amount}) }} {{ getPrice(card) * card.amount }} <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon">
                </a>
            </div>

            <a v-if="card.cardmarket && card.language === 'en' && card.set.series !== 'Trading Card Game Pocket'" :href="card.cardmarket.url" class="btn w-100 text-center text-white mt-2" target="_blank" style="background-color: #012169">
                {{ $t('cardInfo.showOn') }} <img src="/assets/dipocaco/cardmarket.png" style="height: 1.1em;">
            </a>

            <div class="row p-0 mt-2">
                <div class="col-6 pl-0">
                    <a :href="getLinkToCard(card)" class="btn btn-dark w-100"><i class="fa-solid fa-arrow-up-right-from-square"></i> Link</a>
                </div>
                <div class="col-6 pr-0">
                    <a href="javascript:" v-if="canShare" v-on:click="shareCard()" class="btn btn-dark w-100"><i class="fa-solid fa-share-from-square"></i> {{ $t('cardInfo.share') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CardService from "../../CardService";

export default {
    name: "CardDetailViewCanvas",
    props: {
        card: Object,
        gallery: {type: Boolean, default: false},
    },
    computed: {
        canShare() {
            return navigator.share;
        }
    },
    watch: {
        card(val, preVal) {
            if (val !== preVal && val) {
                this.checkIfCardIsOwned();
            }
        }
    },
    mounted() {
        this.checkIfCardIsOwned();
    },
    methods: {
        getPrice(card) {
            return CardService.getPrice(card);
        },
        closeModal() {
            $("#card-detail-view-canvas").offcanvas('hide');
        },
        shareCard() {
            if (navigator.share) {
                let imageSource = CardService.getCardImageUrl(this.card);

                fetch(imageSource)
                    .then(r => r.blob())
                    .then(r => {
                        let file = new File([r], 'Card.png', {
                            type: 'image/png',
                        });

                        navigator.share({
                            title: this.$i18n.t('cardInfo.shareTitle', {title: this.card.title}),
                            text: this.$i18n.t('cardInfo.shareMessage', {set: this.card.set.name}),
                            url: 'https://dipocaco.me/card/' + this.card.id,
                            files: [file]
                        }).then(() => console.log('Successful share'))
                    })
            }
        },
        getCardImageUrl(card) {
            return CardService.getCardImageUrl(card);
        },
        getLinkToCard(card) {
            return '/card/' + card.id;
        },
        copyCardID(id) {
            navigator.clipboard.writeText(id)
            iziToast.success({title: this.$i18n.t('cardInfo.copiedID')})
        },
        checkIfCardIsOwned() {
            if (this.card && !this.card.hasOwnProperty('is_in_set_collection')) {
                axios.get('/api/cards/in-collection/'+this.card.id).then((response) => {
                    this.card.is_in_set_collection = !!response.data;
                })
            }
        },
        removeCardFromCollection(userCollectionCardId) {
            $("#remove-card-modal").offcanvas('toggle');

            axios.get('/api/collection/remove-card/'+userCollectionCardId).then((response) => {
                iziToast.success({title: response.data.message});
                this.$emit('cardRemoved', true);
            });
        },
        removeAllFromCardFromCollection(userCollectionCardId) {
            $("#remove-card-modal").offcanvas('toggle');

            axios.get('/api/collection/remove-all/'+userCollectionCardId).then((response) => {
                iziToast.success({title: response.data.message});
                this.$emit('cardRemoved', true);
            });
        },
        setAsCollectionCover(card) {
            console.log(card)
            $("#remove-card-modal").offcanvas('toggle');

            axios.post('/api/collection/cover', {
                card: card.userCollectionCardId
            }).then((response) => {
                iziToast.success({title: response.data.message});
            });
        }
    }
}
</script>

<style lang="scss" scoped>
#card-detail-view-canvas {
    z-index: 1500;
}

.card-image {
    max-width: 100%;
    border-radius: 20px;
}

.currency-icon {
    max-height: 2em;
}

.set-logo {
    max-height: 3em;
    max-width: 10em;
}

.set-icon {
    max-height: 1.8em;
}

.modal-footer {
    display: flex;
    justify-content: space-evenly;
}

.card-new-marker {
    margin-top: -0.2em;
    margin-left: 0.2em;
    height: 1em;
    display: inline-block;
}
</style>
